import { gql } from '../../__generated__/gql'

export const MARK_LEVEL_CELEBRATED_MUTATION = gql(`
  mutation markLevelCelebrated($level: Int!) {
    markLevelCelebrated(input: { level: $level }) {
      user {
        id
        communityProfile {
          levelCelebrations {
            level
          }
          levelInfo {
            level
          }
        }
      }
    }
  }
`)
